/**
* @author ayou[beica1@outook.com]
* @date 2022/1/19 14:24
* @description
*   TheSpecifiedAnalysis.vue of WeTrade
*/
<template>
<router-link
  :to="`/advice/${advice.id}?f=${$route.name==='symbol' ? 1 : 0}`"
>
  <div class="mt-8 pb-16" style="border-bottom: 1px solid var(--color-border);">
    <div class="df-middle df-between py-8 list-item"
      style="height: 48px;">
      <Icon class="p-0" :class="{'c-success': isUp, 'c-danger': !isUp}" sm
        :name=" isUp ? 'up': 'down'" />
      <p class="flex-1 ml-16" :class="{ 'c-success': isUp, 'c-danger': !isUp }">
        {{advice.informactionContent && advice.informactionContent.split(',')[0]}}
      </p>
      <div class="t-right f-sm flex-1 c-tip">
        <Time :format="'dd-MM-yyyy HH:mm:ss'" :time="advice.createTime" />
      </div>
    </div>
    <div class="px-6 p-wrap"
      style="line-height: 20px;" ref="paragraph">
      {{ advice.contentTitle.substr(0, maxWordNum) }}
      <div class="more">...<t path="symbol_103" class="c-primary ml-4">More</t></div>
    </div>
  </div>
</router-link>
</template>

<script lang="ts">
import { TradeDirection } from '@/types'
import { computed, defineComponent, onMounted, shallowRef } from 'vue'
import Icon from '@/components/Icon.vue'
import Time from '@/components/Time.vue'
import { formatDateTime } from '@/common/format'

export default defineComponent({
  name: 'TheSpecifiedAnalysis',
  components: { Time, Icon },
  props: {
    advice: {
      type: Object,
      required: true,
    },
  },
  setup (props) {
    const paragraph = shallowRef<HTMLElement>()
    const today = formatDateTime('MM-dd-yy', new Date().getTime())
    const maxWordNum = shallowRef(0)

    const createDay = computed(() => {
      return formatDateTime('MM-dd-yy', props.advice.createTime)
    })

    onMounted(() => {
      if (paragraph.value) {
        const aLineWords = (paragraph.value.offsetWidth - 12) / 6.92
        maxWordNum.value = Math.floor(aLineWords * 2.3)
      }
    })

    const isUp = computed(() => {
      return props.advice.direction === TradeDirection.BUY
    })

    return {
      today,
      createDay,
      isUp,
      paragraph,
      maxWordNum,
    }
  },
})
</script>
<style scoped lang="scss">
.p-wrap{
  word-break: break-all;
  display: -webkit-box;
}
.more{
  display: inline-block;
}
</style>
